/* eslint-disable jsx-a11y/href-no-hash */

import i18n from "lib/i18n";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { ThemeProvider } from "@theconversation/ui";
import { ajax as $ajax } from "jquery";
import Flash from "lib/flash";

import Dialog from "../RemoveComment/Dialog";

/**
 * The remove all comments of a user component.
 * This component renders a link that'll trigger a dialog, where editors must choose the removal reason
 * for all user comments.
 */
export default function RemoveAllComments({
  buttonText,
  className,
  removeCommentsPath,
  userName,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const buttonCopy = buttonText || i18n.t("editorial_comments.actions.remove_all_comments_by_user", { name: userName });

  const onSubmitDialog = ({ removalReason, requireModeration, notes }) => {
    $ajax({
      url: removeCommentsPath,
      method: "POST",
      dataType: "json",
      data: {
        future_comments_require_moderation: requireModeration,
        notes,
        reason: removalReason,
      },
      success: () => {
        location.reload();
      },
      error: () => {
        Flash.now("alert", i18n.t("editorial_comments.error.message"));
      },
    });
  };

  return (
    <ThemeProvider>
      <a
        href="#"
        className={className}
        onClick={(event) => {
          event.preventDefault();
          setModalOpen(true);
        }}
      >
        {buttonCopy}
      </a>

      <Dialog
        closeModal={() => setModalOpen(false)}
        dialogTitle={i18n.t("editorial_comments.headers.remove_all_comments")}
        onSubmitDialog={onSubmitDialog}
        open={modalOpen}
        userName={userName}
      />
    </ThemeProvider>
  );
}

RemoveAllComments.defaultProps = {
  buttonText: "",
  className: "destroy danger button",
};

RemoveAllComments.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  removeCommentsPath: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};
